var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "form-rating-scale" } }, [
    _c("div", { class: "form-rating-scale rating-align-" + _vm.localAlign }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.localFieldLabel,
            expression: "localFieldLabel",
          },
        ],
        staticClass: "form-rating-scale-title",
        attrs: { type: "text", placeholder: "Bir soru girin" },
        domProps: { value: _vm.localFieldLabel },
        on: {
          blur: _vm.updateField,
          input: function ($event) {
            if ($event.target.composing) {
              return
            }
            _vm.localFieldLabel = $event.target.value
          },
        },
      }),
      _vm._v(" "),
      _c("div", [
        _c(
          "div",
          { staticClass: "scale" },
          _vm._l(5, function (n) {
            return _c("label", { key: n }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.localRating,
                    expression: "localRating",
                  },
                ],
                attrs: { type: "radio" },
                domProps: { value: n, checked: _vm._q(_vm.localRating, n) },
                on: {
                  change: [
                    function ($event) {
                      _vm.localRating = n
                    },
                    _vm.updateField,
                  ],
                },
              }),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(n))]),
            ])
          }),
          0
        ),
        _vm._v(" "),
        _c("div", { staticClass: "scale-labels" }, [
          _c("span", [_vm._v(_vm._s(_vm.localSubLabelOne))]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.localSubLabelTwo))]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }